import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardStateService {

  lastOpened$ = new BehaviorSubject<string>(null);
  constructor() { }
}
